import { getAllListableCashflows } from './../../../utils/states-management/selector/cashflow-selector';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccountingEntryCategorie } from 'src/app/models/accounting/accounting_entries_categories';
import { getTotalsAccountingCategoriesResult } from 'src/app/utils/states-management/selector/dashboard.selector';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { PopoverController } from '@ionic/angular';
import { BookCashflowListFilter } from '../cashflow/book/book.component';
import {
  deleteCashflow,
  paginateCashflow,
} from 'src/app/utils/states-management/actions/cashflow.action';
import { Subscription, filter, lastValueFrom, take } from 'rxjs';
import { getCashflowPaginationResult } from 'src/app/utils/states-management/selector/cashflow-selector';
import { cloneDeep } from 'lodash';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { ConnectionService } from 'src/app/services/connection.service';
import { ModalCashflowEntryListComponent } from '../modal-cashflow-entry-list/modal-cashflow-entry-list.component';

@Component({
  selector: 'app-book',
  templateUrl: './book.page.html',
  styleUrls: ['./book.page.scss'],
})
export class BookPage implements OnInit, AfterViewInit {
  accountingCategories: Array<AccountingEntryCategorie>;
  @Input() bookCashflowListFilter: BookCashflowListFilter = {
    startDate: null,
    endDate: null,
    filterCategory: [],
    filterType: [],
    categorieIsFiltred: null,
    cashflowTypeIsFiltred: null,
    is_loading: true,
    isFiltred: false,
    page: 1,
    page_size: 20,
    isHarvestingFilter: false,
    autoLoadEnabled: true,
  };

  subscriptions: Array<Subscription> = [];
  isOnline = true;
  constructor(
    private popOverController: PopoverController,
    private toastUtils: ToastUtils,
    private store: Store,
    private route: ActivatedRoute,
    private connectionService: ConnectionService,
  ) {
    this.connectionService.isOnline$.subscribe(isOnline => {
      this.isOnline = isOnline;
    })
  }

  async ngAfterViewInit() {

    this.route.queryParams.subscribe((params) => {
      if (params['idCategory']) {
        this.bookCashflowListFilter.filterCategory.push(params['idCategory']);
      }
    });
    this.bookCashflowListFilter.is_loading = true;
    let { data } = await lastValueFrom(
      this.store.select(getTotalsAccountingCategoriesResult).pipe(take(1))
    );
    this.accountingCategories = data;
    console.log(this.entries)
    let entries = await lastValueFrom(this.store.select(getAllListableCashflows).pipe(take(1)))
    console.log(entries)
    if (entries.length === 0) {
      this.store.dispatch(
        paginateCashflow({
          startDate: this.bookCashflowListFilter.startDate,
          endDate: this.bookCashflowListFilter.endDate,
          page: this.bookCashflowListFilter.page,
          page_size: this.bookCashflowListFilter.page_size,
          accountings_entries: this.bookCashflowListFilter.filterCategory,
          natures: this.bookCashflowListFilter.filterType,
          is_harvesting_filter: this.bookCashflowListFilter.isHarvestingFilter,
        })
      );
    }

    this.prepareList();
  }

  async ngOnInit() {

  }

  handelFilterChange(value) {
    this.bookCashflowListFilter.is_loading = true;

    this.store.dispatch(
      paginateCashflow({
        startDate: value.startDate,
        endDate: value.endDate,
        page: this.bookCashflowListFilter.page,
        page_size: this.bookCashflowListFilter.page_size,
        accountings_entries: value.filterCategory,
        natures: this.bookCashflowListFilter.filterType,
        is_harvesting_filter: this.bookCashflowListFilter.isHarvestingFilter,
      })
    );
  }
  async presentCashFlowInputModal() {

    let componentProps = {
      modalController: this.popOverController,
    };
    const popover = await this.toastUtils.popOverBuilder(
      componentProps,
      ModalCashflowEntryListComponent,
      ['popover_class', 'diario']
    );
    await popover.onWillDismiss();


  }
  paginationResult;
  entries = [];
  localEntriesAll = [];
  localLastPage = 0;
  isAddBtnClicked;
  productionsPerfarm;
  country;
  async prepareList() {
    this.bookCashflowListFilter.is_loading = true;

    const normalizeId = (val: any): number => {
      if (typeof val === 'number') return val;
      const match = /(-?\d+)$/.exec(val);
      return match ? parseInt(match[1], 10) + 1e9 : Number.MAX_SAFE_INTEGER;
    };

    this.subscriptions.push(
      this.store
        .select(getCashflowPaginationResult)
        .pipe(
          map(({ paginationResult, entities }) => {
            const allEntries = Object.values(entities);
            // sort once – newer date first, then id
            allEntries.sort((a: any, b: any) => {
              const dateDiff = new Date(b.date).getTime() - new Date(a.date).getTime();
              if (dateDiff !== 0) return dateDiff;
              return normalizeId(b.id) - normalizeId(a.id);
            });
            return { paginationResult, allEntries };
          }),
          distinctUntilChanged((prev, curr) => prev.paginationResult === curr.paginationResult && prev.allEntries === curr.allEntries)
        )
        .subscribe(({ paginationResult, allEntries }) => {
          this.paginationResult = paginationResult;
          this.localEntriesAll = allEntries;

          this.localLastPage = Math.ceil(
            allEntries.length / this.bookCashflowListFilter.page_size
          );

          const sliceEnd = this.bookCashflowListFilter.page * this.bookCashflowListFilter.page_size;
          this.entries = allEntries.slice(0, sliceEnd);

          this.bookCashflowListFilter.is_loading = false;
          this.showBottomProgress = false;
        })
    );
  }

  loadMore() {
    this.bookCashflowListFilter.page += 1;
    this.showBottomProgress = true;

    this.store.dispatch(
      paginateCashflow({
        startDate: this.bookCashflowListFilter.startDate,
        endDate: this.bookCashflowListFilter.endDate,
        page: this.bookCashflowListFilter.page,
        page_size: this.bookCashflowListFilter.page_size,
        accountings_entries: this.bookCashflowListFilter.filterCategory,
        natures: this.bookCashflowListFilter.filterType,
        is_harvesting_filter: this.bookCashflowListFilter.isHarvestingFilter,
      })
    );
  }
  showBottomProgress: boolean = false;

  async logScrollEnd(event) {
    const contentEl = event.target as HTMLElement;
    const lastEl = contentEl.querySelector(
      'app-book-single-entry.last'
    ) as HTMLElement | null;

    if (lastEl) {
      const contentRect = contentEl.getBoundingClientRect();
      const lastRect = lastEl.getBoundingClientRect();

      const isLastVisible =
        lastRect.top < contentRect.bottom &&
        lastRect.bottom <= contentRect.bottom + 2;

      if (isLastVisible) {
        const nextPage = this.bookCashflowListFilter.page + 1;


        if (nextPage <= this.localLastPage) {
          this.bookCashflowListFilter.page = nextPage;
          const sliceEnd = this.bookCashflowListFilter.page * this.bookCashflowListFilter.page_size;
          this.entries = this.localEntriesAll.slice(0, sliceEnd);
          return;
        }


        if (nextPage <= this.paginationResult?.meta?.last_page) {
          this.bookCashflowListFilter.page = nextPage;
          this.showBottomProgress = true;
          this.store.dispatch(
            paginateCashflow({
              startDate: this.bookCashflowListFilter.startDate,
              endDate: this.bookCashflowListFilter.endDate,
              page: this.bookCashflowListFilter.page,
              page_size: this.bookCashflowListFilter.page_size,
              accountings_entries: this.bookCashflowListFilter.filterCategory,
              natures: this.bookCashflowListFilter.filterType,
              is_harvesting_filter: false,
            })
          );
        }
      }
    }
  }

  async deleteEntry(value) {
    // this.bookCashflowListFilter.page = 1;
    if (value && value.id) {
      this.store.dispatch(deleteCashflow({ id: value.id }));
    }
  }
}
